export const getTenantKeyParts = (hostname = globalThis.location.hostname) =>
  hostname.split(".").toReversed();

export const getTenantKey = (hostname = globalThis.location.hostname) =>
  getTenantKeyParts(hostname).join(".");
